import React, {Component} from 'react'
import { Router, Route, browserHistory, IndexRoute } from 'react-router'
import * as firebase from 'firebase'

import Login from './Login'
import Wrap from './View/Wrap'
import Home from './View/Home'
import Dashboard from './View/Dashboard'
import Dealer from './View/Dealer'
import Contact from './View/Contact'
import Thanks from './View/Thanks'
import NoMatch from './View/404'
import Blog from './View/Blog/Blog'
import Youtube from './Component/Youtube'
import KnowledgeBase from './View/Blog/KnowledgeBase'
import DrainFly from './View/Blog/DrainFly'
import DustMite from './View/Blog/DustMite'
import DengueFever from './View/Blog/DengueFever'
import Admin from './View/Admin'
import Add from './View/Blog/Add'

const config = {
  apiKey: "AIzaSyCpYVcUvrI5nWTyRbyuiOaYDLuPNhueoaI",
  authDomain: "jeyutech-b1f18.firebaseapp.com",
  databaseURL: "https://jeyutech-b1f18.firebaseio.com",
  projectId: "jeyutech-b1f18",
  storageBucket: "jeyutech-b1f18.appspot.com",
  messagingSenderId: "128385267055"
};
firebase.initializeApp(config);

class Loginrouter extends Component {

  render() {
    return(
       <Router history={browserHistory}>
        <Route path="/" component={Wrap}>
         <IndexRoute component={Home}/>
         <Route path="/Login" component={Login} />
         <Route path="/Dealer" component={Dealer} />
         <Route path="/Contact" component={Contact} />
         <Route path="/Thanks" component={Thanks} />
         <Route path="/Blog" component={Blog} />
         <Route path="/KnowledgeBase" component={KnowledgeBase} />
         <Route path="/Video" component={Youtube} />
         <Route path="/Drain_Fly" component={DrainFly} />
         <Route path="/Dust_Mite" component={DustMite} />
         <Route path="/Dengue_Fever" component={DengueFever} />
        </Route>
        <Route path="/JeyuTechAdmin" component={Admin}>
         <IndexRoute component={Dashboard}/>
         <Route path="/Dashboard" component={Dashboard} />
         <Route path="/Add" component={Add} />
        </Route>
        <Route path="*" component={NoMatch} />
       </Router>
    )
  }
}

export default class Jrouter extends Component {
  render() {
    return <Loginrouter />
  }
}



// WEBPACK FOOTER //
// ./src/Jrouter.js